import { ForecastListEffects } from './forecast-list.effects'
import { FORECAST_LIST_FACADE, ForecastListFacade } from './forecast-list.facade'
import { forecastListState } from './forecast-list.reducer'
import { forecastListFeatureKey } from './forecast-list.state'

export * from './forecast-list.facade'

export const FORECAST_LIST_REDUCER = { [forecastListFeatureKey]: forecastListState }
export const FORECAST_LIST_PROVIDERS = [{ provide: FORECAST_LIST_FACADE, useClass: ForecastListFacade }]
export const FORECAST_LIST_EFFECTS = [ForecastListEffects]
